<template>
  <div
    class="wrapper"
    :class="[{ 'nav-open': $sidebar.showSidebar }, { rtl: $route.meta.rtlActive }]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
      :sidebarLinks="menus"
      ref="sideBar"
    >
      <!-- <user-menu></user-menu> -->
      <mobile-menu></mobile-menu>
      <!-- <template slot="links">
        <sidebar-item
          :link="{ name: '首页', icon: 'dashboard', path: '/dashboard' }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{ name: '课程编辑', icon: 'edit_document', path: '/design' }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{ name: '课程管理', icon: 'topic', path: '/course' }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{ name: '资源库管理', icon: 'space_dashboard', path: '/resourceLibrary' }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: '模型资源库',
            icon: '3d_rotation',
            path: '/devicelib',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{ name: '仿真实训', icon: 'vrpano', path: '/simclass' }"
        ></sidebar-item>
        <sidebar-item :link="{ name: '开发中心', icon: 'developer_mode' }">
          <sidebar-item
            :link="{ name: '模型申请', path: '/applymod' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: '模型审核', path: '/auditmod' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: '模型开发', path: '/devmod' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: '编译申请', path: '/applycomplie' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: '编译审核', path: '/auditcompile' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{ name: '考核评价', icon: 'fact_check' }">
          <sidebar-item
            :link="{ name: '试题库', icon: 'vrpano', path: '/title' }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: '在线考核',
              icon: 'precision_manufacturing',
              path: '/examation',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: '过程评价', icon: 'vrpano', path: '/process' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{ name: '用户信息', icon: 'manage_accounts' }">
          <sidebar-item
            :link="{ name: '帐号信息', path: '/user' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: '更改密码', path: '/password' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{ name: '系统管理', icon: 'web_stories' }">
          <sidebar-item
            :link="{ name: '用户管理', path: '/useradmin' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: '用户组管理', path: '/userGroup' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: '动态模板管理', path: '/formwork' }"
          ></sidebar-item>
        </sidebar-item>
      </template> -->
    </side-bar>
    <div class="main-panel" style="position: relative;">
      <!-- <img src="https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/temp/%E5%90%8C%E7%AB%8B%E6%96%B9logo.png" alt="" style="width: 160px;height: 41.6px;    position: absolute;top: 10px;left: 10px;"> -->
      <top-navbar v-if="isMobiles()"></top-navbar>

      <!-- <fixed-plugin
        :color.sync="sidebarBackground"
        :colorBg.sync="sidebarBackgroundColor"
        :sidebarMini.sync="sidebarMini"
        :sidebarImg.sync="sidebarImg"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin> -->

      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith('Win');
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar('sidebar');
    initScrollbar('sidebar-wrapper');
    initScrollbar('main-panel');

    docClasses.add('perfect-scrollbar-on');
  } else {
    docClasses.add('perfect-scrollbar-off');
  }
}
const castMenus = menus => {};

import TopNavbar from './TopNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import MobileMenu from './Extra/MobileMenu.vue';
import FixedPlugin from '../../FixedPlugin.vue';
import UserMenu from './Extra/UserMenu.vue';
import { ZoomCenterTransition } from 'vue2-transitions';
import { getMenus } from '@/api/auth/menu';
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['isMobile']),
  },
  components: {
    TopNavbar,
    ContentFooter,
    FixedPlugin,
    MobileMenu,
    UserMenu,
    ZoomCenterTransition,
  },

  data() {
    return {
      sidebarBackgroundColor: 'black',
      sidebarBackground: 'green',
      sidebarBackgroundImage: './img/sidebar-2.jpg',
      sidebarMini: true,
      sidebarImg: true,
      iconDict: {
        '/dashboard': 'dashboard',
        '/design': 'note',
        '/course': 'topic',
        '/resourceLibrary': 'space_dashboard',
        '/devicelib': '3d_rotation',
        '/simclass': 'vrpano',
        '/devCenter': 'developer_mode',
        '/applymod': 'webhook',
        '/allLibrary': 'developer_board',
        '/thirdPartySoft': 'app_shortcut',
        '/data': 'data_object',
      },
      menus: [
        // { name: '首页', icon: 'dashboard', path: '/dashboard' }
        // , { name: '课程编辑', icon: 'edit_document', path: '/design' }
        // , { name: '课程管理', icon: 'topic', path: '/course' }
        // , { name: '资源库管理', icon: 'space_dashboard', path: '/resourceLibrary' }
        // , { name: '模型资源库', icon: '3d_rotation', path: '/devicelib', }
        // , { name: '仿真实训', icon: 'vrpano', path: '/simclass' }
        // , { name: '开发中心', icon: 'developer_mode', children: [
        //   { name: '模型申请', path: '/applymod' }
        //   , { name: '模型审核', path: '/auditmod' }
        //   , { name: '模型开发', path: '/devmod' }
        //   , { name: '编译申请', path: '/applycomplie' }
        //   , { name: '编译审核', path: '/auditcompile' }
        // ] }
        // , { name: '动态模板管理', path: '/formwork' }
      ],
    };
  },
  methods: {
    isMobiles() {
      let str = true;
      if (this.isMobile.isMobile && this.routeName().path == '/simclass') {
        str = false;
      } else if (this.isMobile.isMobile && this.routeName().path == '/applymod') {
        str = false;
      } else if (this.isMobile.isMobile && this.routeName().path == '/thirdPartySoft') {
        str = false;
      } else if (this.isMobile.isMobile && this.routeName().path == '/devicelib') {
        str = false;
      } else if (this.isMobile.isMobile && this.routeName().path == '/resourceLibrary') {
        str = false;
      } else if (this.isMobile.isMobile && this.routeName().path == '/resourceLib') {
        str = false;
      } else if (this.isMobile.isMobile && this.routeName().path == '/demand') {
        str = false;
      } else if (this.isMobile.isMobile && this.routeName().path == '/devmod') {
        str = false;
      } else if (this.isMobile.isMobile && this.routeName().path == '/auditmod') {
        str = false;
      } else if (this.isMobile.isMobile && this.routeName().path == '/designDetail') {
        str = false;
      }
      return str;
    },
    routeName() {
      let obj = {
        name: '',
        path: '',
      };
      if (this.$route.path == '/design') {
        //课程管理
        obj = {
          name: '课程列表',
          path: '/design',
        };
      } else if (this.$route.path == '/simclass') {
        //数字课堂

        obj = {
          name: '数字课堂',
          path: '/simclass',
        };
      } else if (this.$route.path == '/applymod') {
        //模型申请

        obj = {
          name: '模型申请',
          path: '/applymod',
        };
      } else if (this.$route.path == '/devicelib') {
        //模型申请

        obj = {
          name: '模型资源库',
          path: '/devicelib',
        };
      } else if (this.$route.path == '/resourceLibrary') {
        //媒体资源库

        obj = {
          name: '媒体资源库',
          path: '/resourceLibrary',
        };
      } else if (this.$route.path == '/resourceLib') {
        //模型申请

        obj = {
          name: '特效资源库',
          path: '/resourceLib',
        };
      } else if (this.$route.path == '/demand') {
        obj = {
          name: '需求审批',
          path: '/demand',
        };
      } else if (this.$route.path == '/devmod') {
        obj = {
          name: '模型开发',
          path: '/devmod',
        };
      } else if (this.$route.path == '/auditmod') {
        obj = {
          name: '模型审核',
          path: '/auditmod',
        };
      } else if (this.$route.path == '/applycomplie') {
        obj = {
          name: '编译申请',
          path: '/applycomplie',
        };
      } else if (this.$route.path == '/auditcompile') {
        obj = {
          name: '编译审核',
          path: '/auditcompile',
        };
      }  else if (this.$route.path == '/thirdPartySoft') {
        obj = {
          name: '第三方软件',
          path: '/thirdPartySoft',
        };
      }  else if (this.$route.path == '/designDetail') {
        obj = {
          name: '课程管理详情页面',
          path: '/designDetail',
        };
      }

      return obj;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    this.$EventBus.$off('aaaaaaaa');
    let _this = this;
    this.$EventBus.$on('aaaaaaaa', function () {
      _this.toggleSidebar();
    });

    getMenus().then(menuRes => {
      this.menus = menuRes.data.map(item => {
        let children;
        if (item.children !== undefined) {
          children = item.children.map(childMenu => {
            return {
              name: childMenu.meta.title,
              path: childMenu.path,
              icon: this.iconDict[childMenu.path],
            };
          });
        }
        let menu = {
          name: item.meta.title,
          path: item.path,
          icon: this.iconDict[item.path],
          children,
        };
        return menu;
      });
      reinitScrollbar();
      console.log('menuRes :>> ', menuRes);
    });
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
